import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/page.tsx")